@use "../../../styles/breakpoint.module.scss" as *;

.hub {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
}

.body {
    composes: safeContainer from "../../../styles/composable/layout.module.css";
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    text-align: center;
    padding-block: var(--spacer-40);
}

.heading {
    margin-bottom: var(--spacer-8);
    font: var(--font-h-40);
}

.subhead {
    font: var(--font-p-16);
    margin-bottom: var(--spacer-40);
}

.tileGrid {
    composes: listReset from "../../../styles/composable/utility.module.css";
    display: grid;

    /* Doubled grid: 6 columns, each tile spans 2. Lets the last row
     * of 2 tiles land at cols 2-3 and 4-5 — centered between the 3
     * tiles above. A plain 3-col grid can't center 2 items because
     * columns are integer. */
    grid-template-columns: repeat(6, minmax(0, 200px));
    justify-content: center;
    gap: var(--labui-grid-gap);

    @media ($above-mobile) {
        // Default: each tile spans 2 of the 6 grid columns → 3 visual columns
        > * {
            grid-column: span 2;
        }

        // Last-row centering for the 5-spoke layout (3+2). Items 4 and 5
        // shift to cols 2-3 and 4-5 so the bottom row sits centered under
        // the top row's middle.
        > *:nth-child(4):nth-last-child(2) {
            grid-column: 2 / span 2;
        }

        > *:nth-child(5):last-child {
            grid-column: 4 / span 2;
        }
    }

    @media ($below-mobile) {
        grid-template-columns: 1fr;

        > * {
            grid-column: span 1;
        }
    }
}
